import { ArrowRight, Play } from "lucide-react";
import { motion } from "framer-motion";

export default function Hero() {
  return (
    <section
      data-testid="hero-section"
      className="relative min-h-[92vh] flex items-end pb-20 pt-32 overflow-hidden"
    >
      {/* Background image with overlay */}
      <div className="absolute inset-0">
        <img
          src="https://images.pexels.com/photos/927444/pexels-photo-927444.jpeg?w=2000&q=80"
          alt="Cinematic camera"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-graphite-950/70 via-graphite-950/60 to-graphite-950" />
        <div className="absolute inset-0 bg-gradient-to-r from-graphite-950 via-transparent to-transparent" />
      </div>

      <div className="container-x relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
          className="max-w-4xl"
        >
          <div className="overline mb-6 flex items-center gap-3">
            <span className="w-8 h-px bg-gold" />
            Video editor & videomaker · Villongo (BG)
          </div>
          <h1 className="font-display font-semibold text-5xl sm:text-6xl md:text-7xl lg:text-[8vw] leading-[0.9] tracking-tighter">
            Storie che
            <br />
            <span className="italic font-light text-white/80">vendono.</span>
            <br />
            <span className="text-gold">Video che restano.</span>
          </h1>
          <p className="mt-8 max-w-xl text-white/70 text-lg leading-relaxed">
            Reel social, video promozionali ed eventi per ristoranti, palestre e attività locali.
            Cinematici. Curati. Pronti a convertire.
          </p>

          <div className="mt-10 flex flex-wrap items-center gap-4">
            <a data-testid="hero-cta-quote" href="#preventivo" className="btn-gold group">
              Richiedi un preventivo
              <ArrowRight
                strokeWidth={1.5}
                className="w-4 h-4 group-hover:translate-x-1 transition-transform"
              />
            </a>
            <a data-testid="hero-cta-showreel" href="#lavori" className="btn-ghost group">
              <Play strokeWidth={1.5} className="w-4 h-4 fill-white" />
              Guarda lo showreel
            </a>
          </div>

          <div className="mt-16 flex flex-wrap gap-10 pt-10 border-t border-white/10 max-w-2xl">
            {[
              { k: "40+", v: "Progetti consegnati" },
              { k: "3g", v: "Consegna media reel" },
              { k: "4.9★", v: "Feedback clienti" },
            ].map((s) => (
              <div key={s.v} className="flex flex-col">
                <span className="font-display text-4xl font-medium text-white">{s.k}</span>
                <span className="text-xs uppercase tracking-widest text-white/50 mt-1">{s.v}</span>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
}
